import { z } from 'zod';

export const adminAppTabSchema = z.object({
    sref: z.string().optional(),
    href: z.string().optional(),
    idDiv: z.string(),
    label: z.string(),
    icon: z.string(),
    licenseMode: z.union([z.literal('classic'), z.literal('article')]).optional(),
    hook: z.string().optional(),
});
export type AdminAppTab = z.infer<typeof adminAppTabSchema>;

export const adminAppSchema = z.object({
    name: z.string(),
    label: z.string(),
    icon: z.string(),
    color: z.tuple([z.string(), z.string(), z.string()]),
    state: z.string().optional(),
    access: z.boolean(),
    url: z.string().optional(),
    tabs: z.array(adminAppTabSchema).optional(),
});
export type AdminApp = z.infer<typeof adminAppSchema>;

export const adminAppsSchema = z.array(adminAppSchema);
export type AdminApps = z.infer<typeof adminAppsSchema>;
